import React, { useState, useEffect } from "react";
import { QRCodeSVG } from 'qrcode.react';
import { Container, Row, Col, Spinner } from "react-bootstrap";
import style from "./Qr.module.css";
import { Toaster } from "sonner";
import { getUserByEmail } from "../../../utils/index.js";
import CarnetAlumno from "./CarnetAlumno.jsx";

const Qr = () => {
  const [correoUsuario, setCorreoUsuario] = useState(null);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrCodeURL, setqrCodeURL] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar correo del sessionStorage cuando esté disponible
  useEffect(() => {
    const interval = setInterval(() => {
      const correo = sessionStorage.getItem("correo");
      if (correo) {
        setCorreoUsuario(correo);
        clearInterval(interval); // Lo encontramos, detenemos el chequeo
      }
    }, 100); // chequea cada 100ms

    return () => clearInterval(interval);
  }, []);

  const getUserData = async () => {
    try {
      const dataUsuario = await getUserByEmail(correoUsuario);
      setUserData(dataUsuario[0]);
      setLoading(false);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {
    if (correoUsuario) {
      getUserData();
    }
  }, [correoUsuario]);

  useEffect(() => {
    if (userData) {
      setEmail(userData.email || "");
      setFirstName(userData.name || "");
      setLastName(userData.lastName || "");
      setqrCodeURL(userData.shortUrl || userData.email || "");
    }
  }, [userData]);

  return (
    <Container className={style.qrContainer} fluid>
      <Row className="m-0 p-0 py-4 justify-content-center">
        <Col>
          <h1 className={style.title}>
            Hola {firstName || <Spinner animation="grow" />}, <br />¡Te estábamos esperando!
          </h1>
          <h5 className={style.subtitle}>Disfruta de tu actividad</h5>
        </Col>
      </Row>

      <Row className="m-0 p-0 py-4 justify-content-center">
        <Col xs={12} md={4} className="justify-content-center text-center">
          {loading ? (
            <div style={{ color: "#ffffff" }}>
              <Spinner />
            </div>
          ) : qrCodeURL ? (
            <QRCodeSVG value={qrCodeURL} size={256} level="H" marginSize={2}
              bgColor="#ffffff"
              fgColor="#000000" />
          ) : (
            <p>No se pudo generar el código QR.</p>
          )}
        </Col>
        <Toaster richColors position="bottom-center" />
      </Row>

      <Row className="m-0 p-0 py-4 justify-content-center">
        {!loading && userData && (
          <CarnetAlumno
            name={`${userData.name} ${userData.lastName}`}
            qrValue={qrCodeURL}
          />
        )}
      </Row>
    </Container>
  );
};

export default Qr;
